import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import useNavigation from "../../hooks/useNavigation";
import useCheckBinding from "../../hooks/useCheckBinding";
import { formatPrice } from "../../utils";
import WalletStatusItem from "./WalletStatusItem";
import { WalletInfoProps } from "./types";
import backImg from "../../assets/images/wallet/walletGroup.png";
import creditImg from "../../assets/images/wallet/credit.png";
import notVerifiedImg from "../../assets/images/wallet/notverified.png";
import verifiedImg from "../../assets/images/wallet/verified.png";
import phoneNotBindImg from "../../assets/images/wallet/phoneNotBind.png";
import phoneBindImg from "../../assets/images/wallet/phoneBind.png";
import transferImg from "../../assets/images/wallet/transfer.png";
import receiveImg from "../../assets/images/wallet/receive.png";

const Box = styled.div`
  border-radius: 12px;
  overflow: hidden;
  padding: 5px 15px;
`;
const ViewRow = styled.div`
  border-radius: 12px;
  padding: 12px;
  background: url(${backImg}) center/cover no-repeat;
`;
const Label = styled.div`
  font-size: 13px;
  color: rgb(181, 227, 255);
`;
const MoneyRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin: 8px 0;
`;
const Money = styled.div`
  font-size: 30px;
  color: #fff;
`;
const Unit = styled.span`
  font-size: 13px;
  color: rgb(181, 227, 255);
`;
const DetailRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
const DetailLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;
const TransferRow = styled.div`
  display: flex;
  background: #fff;
  border-radius: 0 0 12px 12px;
  margin-top: -4px;
`;
const TransferBtn = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 0;
  border: 0;
  background: #fff;
  cursor: pointer;
  font-size: 15px;
`;
const Icon = styled.img`
  width: 22px;
  height: 22px;
`;

const creditTextOf = (credit_score = 0) => {
  if (credit_score >= 700) return "信用极好";
  if (credit_score >= 650) return "信用优秀";
  if (credit_score >= 600) return "信用良好";
  if (credit_score >= 550) return "信用中等";
  return "信用极差";
};

const WalletInfo: React.FC<WalletInfoProps> = ({
  is_id_verify,
  is_phone_verify,
  credit_score,
  balance,
}) => {
  const navigation = useNavigation();
  const { handleCheckBindingWpPassword } = useCheckBinding();
  return (
    <Box>
      <ViewRow>
        <Row>
          <Label>账户余额</Label>
          <WalletStatusItem
            onPress={() => navigation.navigate("CreditRating")}
            imgSrc={creditImg}
            title={creditTextOf(credit_score)}
          />
          <WalletStatusItem
            onPress={() => navigation.navigate("Verified")}
            imgSrc={is_id_verify ? verifiedImg : notVerifiedImg}
            title={is_id_verify ? "已实名" : "未实名"}
          />
          <WalletStatusItem
            onPress={() => navigation.navigate("PhoneBinding")}
            imgSrc={is_phone_verify ? phoneBindImg : phoneNotBindImg}
            title={is_phone_verify ? "已绑定" : "未绑定"}
          />
        </Row>
        <MoneyRow>
          <Money>{formatPrice(balance || 0)}</Money>
          <Unit>喜鹊币</Unit>
        </MoneyRow>
        <DetailRow>
          <Label>≈ ¥ {formatPrice(balance || 0)} CNY</Label>
          <DetailLink type="button" onClick={() => navigation.navigate("WalletLog")}>
            钱包详情
            <span aria-hidden style={{ fontSize: 12 }}>
              ›
            </span>
          </DetailLink>
        </DetailRow>
      </ViewRow>
      <TransferRow>
        <TransferBtn
          type="button"
          onClick={() =>
            handleCheckBindingWpPassword().then(() =>
              navigation.navigate("Transfer")
            )
          }
        >
          <Icon src={transferImg} alt="" />
          转账
        </TransferBtn>
        <TransferBtn
          type="button"
          onClick={() => navigation.navigate("Receive")}
        >
          <Icon src={receiveImg} alt="" />
          收款
        </TransferBtn>
      </TransferRow>
    </Box>
  );
};

export default observer(WalletInfo);
